import { NestedFolderPicker } from '../NestedFolderPicker/NestedFolderPicker';

export const FolderPicker = NestedFolderPicker;
